// twoHelixes funnel events (th.js loads async from index.html; calls before it
// arrives are queued by the inline stub). No-ops during SSR.
type Th = (...args: unknown[]) => void

export function th(...args: unknown[]): void {
  try {
    ;(globalThis as { th?: Th }).th?.(...args)
  } catch { /* analytics must never break the app */ }
}

export const track = (event: string, props?: Record<string, unknown>) => th('track', event, props)
export const identify = (userId: string | null) => th('identify', userId)
